import { render, staticRenderFns } from "./dictionariesCategoryManage.vue?vue&type=template&id=cca77a78&scoped=true&"
import script from "./dictionariesCategoryManage.vue?vue&type=script&lang=js&"
export * from "./dictionariesCategoryManage.vue?vue&type=script&lang=js&"
import style0 from "./dictionariesCategoryManage.vue?vue&type=style&index=0&id=cca77a78&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cca77a78",
  null
  
)

export default component.exports